import actions from './actions'
import state from './state'
import mutations from './mutations'

const project = {
  state: state,
  mutations: mutations,
  actions
}

export default project



// WEBPACK FOOTER //
// ./src/store/project/index.js